import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-dashboard',
  templateUrl: './contact-dashboard.component.html',
  styleUrls: ['./contact-dashboard.component.scss']
})
export class ContactDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
